import { Box, Grid } from "@mui/material";
import { ReactNode } from "react";

interface PainelSecaoProps {
    ativo: boolean;
    children: ReactNode;
}

/**
 * Painel de uma seção de configuração. Os painéis inativos são apenas
 * escondidos (e não desmontados) para preservar o estado dos formulários.
 */
export const PainelSecao = ({ ativo, children }: PainelSecaoProps) => (
    <Box role="tabpanel" sx={{ display: ativo ? "block" : "none" }}>
        <Grid container spacing={2} alignItems="stretch">
            {children}
        </Grid>
    </Box>
);
